import { useEffect, useState } from 'react'

/** Versão publicada (gerada a cada build em /version.json). */
export function useVersaoSistema() {
  const [v, setV] = useState(null)
  useEffect(() => {
    let vivo = true
    fetch(`${import.meta.env.BASE_URL || '/'}version.json?t=${Date.now()}`, { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivo && d?.gerado_em) setV(d) })
      .catch(() => {})
    return () => { vivo = false }
  }, [])
  if (!v) return null
  const d = new Date(v.gerado_em)
  if (isNaN(d.getTime())) return null
  const p = (n) => String(n).padStart(2, '0')
  return {
    ...v,
    rotulo: `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`,
  }
}
